import styled from 'styled-components';

import { HeadingSmallMedium, MinBreakpointV2 } from '@xemplo/style-constants';

export const PromptHeader = styled.div`
  padding: 32px 32px 20px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  ${HeadingSmallMedium};
  & svg {
    width: 40px;
    height: 40px;
  }

  &.extended {
    @media ${MinBreakpointV2.medium} {
      flex-direction: row;
    }
  }
`;
